import { componentStyle } from '@/styling/util/component-style.ts';
import type { FloatLabelDesignTokens } from '@primeuix/themes/types/floatlabel';

export const floatLabelStyle = componentStyle<FloatLabelDesignTokens>({
    root: {
        color: '{color.textSecondary}',
        focusColor: '{color.textSecondary}',
        fontWeight: '400',
    },
});
